import React from "react";
import { MdDashboard, MdDomain, MdPeople, MdAssignment, MdSummarize, MdList, MdEdit, MdSchool, MdTopic } from "react-icons/md";
import PerformanceKPIDashboard from "views/performanceKPI/PerformanceKPIDashboard";
import SectorManagementKPI from "views/performanceKPI/SectorManagementKPI";
import Workers from "views/performanceKPI/Workers";
import Evaluation from "views/performanceKPI/Evaluation";
import EvaluationRecords from "views/performanceKPI/EvaluationRecords";
import Training from "views/performanceKPI/Training";
import TrainingRecords from "views/performanceKPI/TrainingRecords";
import TrainingTopicsManagement from "views/performanceKPI/TrainingTopicsManagement";
import Reports from "views/performanceKPI/Reports";

const performanceKpiRoutes = [
  {
    name: "Dashboard",
    layout: "/performance-kpi",
    path: "dashboard",
    icon: <MdDashboard className="h-6 w-6" />,
    component: <PerformanceKPIDashboard />,
    selectable: true,
  },
  {
    name: "Workers",
    layout: "/performance-kpi",
    path: "workers",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Workers />,
    selectable: true,
  },
  {
    name: "Sector Management & KPI",
    layout: "/performance-kpi",
    path: "sector-management",
    icon: <MdDomain className="h-6 w-6" />,
    component: <SectorManagementKPI />,
    selectable: true,
  },
  {
    name: "Evaluation",
    layout: "/performance-kpi",
    icon: <MdAssignment className="h-6 w-6" />,
    submenu: [
      {
        name: "Evaluate",
        layout: "/performance-kpi",
        path: "evaluation",
        icon: <MdEdit className="h-5 w-5" />,
        component: <Evaluation />,
        selectable: true,
      },
      {
        name: "Evaluation records",
        layout: "/performance-kpi",
        path: "evaluation-records",
        icon: <MdList className="h-5 w-5" />,
        component: <EvaluationRecords />,
        selectable: true,
      },
    ],
  },
  {
    name: "Training",
    layout: "/performance-kpi",
    icon: <MdSchool className="h-6 w-6" />,
    submenu: [
      {
        name: "Training topics",
        layout: "/performance-kpi",
        path: "training-topics",
        icon: <MdTopic className="h-5 w-5" />,
        component: <TrainingTopicsManagement />,
        selectable: true,
      },
      {
        name: "Conduct training",
        layout: "/performance-kpi",
        path: "training",
        icon: <MdEdit className="h-5 w-5" />,
        component: <Training />,
        selectable: true,
      },
      {
        name: "Training records",
        layout: "/performance-kpi",
        path: "training-records",
        icon: <MdList className="h-5 w-5" />,
        component: <TrainingRecords />,
        selectable: true,
      },
    ],
  },
  {
    name: "Reports & Analytics",
    layout: "/performance-kpi",
    path: "reports",
    icon: <MdSummarize className="h-6 w-6" />,
    component: <Reports />,
    selectable: true,
  },
];

export default performanceKpiRoutes;
